export const modelProviderIssue = (providers) => {
  if (providers.length === 0) {
    return { type: "no_model_provider" };
  }
  const defaultProvider = providers.find(({ is_default }) => is_default);
  if (!defaultProvider) {
    return { type: "no_default_model_provider" };
  }
  if (!defaultProvider.enabled) {
    return { type: "default_model_provider_disabled", provider: defaultProvider.provider };
  }
  return void 0;
};
